import * as statements from '../../statements';
import { FactName } from '../../../../../api-types';
const { isFactType, isPregame, playersEntered, isBreak } = statements;
// Mutually exclusive (none should trigger at the same time) break triggers/gfx hooks
// FACT TRIGGERS
// Live period about to start
export const ABOUT_TO_START = (args) => isFactType(FactName.ABOUT_TO_START)(args.fact);
// Need to show teamlist
export const PLAYERS_ENTERING_NOT_PREGAME = (args) => isFactType(FactName.PLAYERS_ENTERING)(args.fact) && !isPregame(args);
export const PLAYERS_ENTERING_PREGAME = (args) => isFactType(FactName.PLAYERS_ENTERING)(args.fact) && isPregame(args);
// SUMMARY ONLY
// Long means we want to use the intro after showing match stats
/*export const BREAK_NOT_PREGAME_LONG = (args: SequenceTriggerArgs) =>
  isBreak(args) && !isPregame(args) && (getCurrentPeriod(args.matchSummary).duration! <= 5);

// Show match stats and finish on summary
export const BREAK_NOT_PREGAME_SHORT = (args: SequenceTriggerArgs) =>
  isBreak(args) && !isPregame(args) && (getCurrentPeriod(args.matchSummary).duration! > 5);

// intro needed
export const BREAK_PREGAME_PRE_PLAYERS = (args: SequenceTriggerArgs) =>
  isPregame(args) && !playersEntered(args);

// intro needed
export const BREAK_PREGAME_PLAYERS = (args: SequenceTriggerArgs) =>
  isPregame(args) && !playersEntered(args);
  */
//# sourceMappingURL=break.js.map